<app-enfaf-modal
  svgIcon="lock-dark"
  [title]="'Verifica tu correo electrónico'"
  [buttonCancelText]="'Cerrar'"
  [buttonConfirmText]="'Verificar'"
  (onClose)="closeModal()"
  (onConfirm)="submitCode()"
  [disableConfirmButton]="code.invalid || loading"
  [isLoading]="loading"
  >
  <div class="verification-code-container">
    <p>Introduce el código recibido por correo electrónico para completar tu registro.</p>

    <enfaf-input
      color="light"
      [control]="code"
      label="Código de verificación"
      name="verificationCode"
      placeholder="Código de verificación"
      autocomplete="one-time-code"
      type="text"
      maxlength="6"
      pattern="[0-9]*"
      (input)="onCodeInput()"
    ></enfaf-input>

    <button class="resend-btn" (click)="resendCode()" [disabled]="timer > 0 || loading" type="button">
      Reenviar código @if (timer > 0) {
      <span>({{ timer }}s)</span>
    }
  </button>
</div>
</app-enfaf-modal>
